export enum LocaleCurrencyEnum {
  USD = 'USD',
  CAD = 'CAD',
}
